export enum ShipTypeEnum {
  DELIVERY = 0,
  DEVOLUTION = 1
}
